<script lang="ts">
  // Pre-game overlay for quiz modes. Shown once per fresh-load while
  // the camera is settling into the region, gives the player a moment
  // to orient before the timer starts. Restart / Retry skip this state
  // and jump straight back to gameplay (the player just made a clear
  // intent to play; no need to make them tap Start again).

  interface Props {
    /** Display name shown atop the start panel. */
    quizName: string;
    /**
     * Total countries in this run's pool — communicates session size
     * up front so the player knows what they're committing to.
     */
    total: number;
    onStart: () => void;
  }

  let { quizName, total, onStart }: Props = $props();
</script>

<div class="quiz-start-screen">
  <div class="quiz-start-screen__panel">
    <div class="quiz-start-screen__title">{quizName}</div>
    <div class="quiz-start-screen__subtitle">
      {total} countries &middot; click each one as it's named
    </div>
    <button
      class="quiz-start-screen__btn"
      type="button"
      onclick={onStart}
    >
      Start
    </button>
  </div>
</div>
